import React, { useState } from "react";
import Button from "../../Button/Button";
import Modal from "../../Modal/Modal";
import "./AddSectionModal.css";

const AddSectionModal = ({ onClose, onAdd }) => {
  const [sectionName, setSectionName] = useState("");

  const handleAdd = () => {
    if (sectionName.trim()) {
      onAdd(sectionName.trim());
      setSectionName("");
    }
  };

  const footer = (
    <>
      <Button variant="outline" onClick={onClose}>
        Cancel
      </Button>
      <Button variant="primary" onClick={handleAdd}>
        Add Section
      </Button>
    </>
  );

  return (
    <Modal
      isOpen={true}
      onClose={onClose}
      title="Add New Section"
      maxWidth="460px"
      footer={footer}
    >
      <div className="section-modal-form-group">
        <label className="section-modal-label">Section Name</label>
        <input
          type="text"
          className="form-control"
          value={sectionName}
          onChange={(e) => setSectionName(e.target.value)}
          placeholder="Enter section name"
        />
      </div>
    </Modal>
  );
};

export default AddSectionModal;


